export const config = {
  primaryColor: "#002C71",
  primaryRGB: [0, 44, 113],
  accentColor: "#F3B229",
  blackColor: "#000000",
  grayColor: "#444444",
  lightGrayColor: "#777777",
  sectionTitleFontSize: 13,
  fieldTitleFontSize: 11,
  normalFontSize: 10,
  fontFamily: "Lato",
  dateFormat: "MMMM DD, YYYY",
};
